import React, { createContext, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [activeTour, setActiveTour] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const startTour = (tourConfig) => {
    setActiveTour(tourConfig);
    setCurrentPageIndex(0);
    setCurrentStepIndex(0);
    setShowModal(true);
    if (location.pathname !== tourConfig.pages[0].path) {
      navigate(tourConfig.pages[0].path);
    }
  };

  const nextStep = () => {
    const currentPage = activeTour.pages[currentPageIndex];
    if (currentStepIndex < currentPage.steps.length - 1) {
      setCurrentStepIndex(currentStepIndex + 1);
    } else if (currentPageIndex < activeTour.pages.length - 1) {
      const nextPage = activeTour.pages[currentPageIndex + 1];
      setCurrentPageIndex(currentPageIndex + 1);
      setCurrentStepIndex(0);
      navigate(nextPage.path);
    } else {
      stopTour();
    }
  };

  const prevStep = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
    } else if (currentPageIndex > 0) {
      const prevPage = activeTour.pages[currentPageIndex - 1];
      setCurrentPageIndex(currentPageIndex - 1);
      setCurrentStepIndex(prevPage.steps.length - 1);
      navigate(prevPage.path);
    }
  };

  const stopTour = () => {
    setShowModal(false);
    setActiveTour(null);
  };

  return (
    <TourContext.Provider
      value={{
        activeTour,
        currentPageIndex,
        currentStepIndex,
        showModal,
        startTour,
        nextStep,
        prevStep,
        stopTour,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);
